import { readStaffAppContext } from '../clinic/seed';
import { card, el } from '../dom';

export function renderProfile(mount: HTMLElement): void {
  const context = readStaffAppContext();
  mount.append(
    el(
      'section',
      { class: 'section' },
      el('h2', {}, 'My Profile'),
      el(
        'p',
        { class: 'lede' },
        'Preview identity for the staff shell. Directory mapping from a Cognito sub is still unresolved — this is seed chrome, not a live clinician record.',
      ),
    ),
    card({
      title: context?.actor.displayName ?? 'No preview session',
      tone: 'held',
      toneLabel: context?.actor.roleTitle ?? 'Signed out',
      body: 'Switch preview role from the staff door or the sidebar to see how a platform admin versus a location owner sees the location switcher.',
      facts: [
        ['Staff id', context?.actor.id ?? '—'],
        ['Current location', context ? `${context.location.name} · ${context.location.code}` : '—'],
        ['Visible locations', context ? String(context.locations.length) : '0'],
      ],
    }),
  );
}
